import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { suspendCards } from '../api/rsimActionsApi.ts';

export const useRSimSuspendMutation = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return suspendCards(props);
    },
  });
};
